module.exports = __webpack_public_path__ + "static/img/stepBg.27b12c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stepBg.png
// module id = XTb/
// module chunks = 51